/**
 * Métodos para eventos
 * @type {Object}
 */
MdHub.event = {
  list: {}, // Lista de eventos

  /**
   * Adiciona um evento a lista
   * @param {String}   name Nome do evento
   * @param {Function} callback  Função a ser executada quando o evento for disparado
   */
  add: function add(name, callback) {
    if (!name || !callback) {
      throw new Error('É necessário informar os parametros: name, callback');
    }
    // Caso não exista uma lista com o mesmo nome, cria
    if (!this.list[name]) {
      this.list[name] = [];
    }

    this.list[name].push(callback);
  },

  /**
   * Dispara os callbacks de um determinado evento
   * @param  {String} name Nome do evento
   * @param  {Object} data Dados que serão repassados ao(s) callback(s) do evento
   * @param  {Object} message Mensagem completa recebida pelo Hub
   */
  call: function call(name, data, message) {
    var i;

    if (!name || typeof name !== 'string') {
      throw new Error('O parametro "name" é obrigatório');
    }

    if (!this.list[name]) {
      return;
    }

    for (i = 0; i < this.list[name].length; i += 1) {
      if (typeof this.list[name][i] === 'function') {
        this.list[name][i].call(this, data, message);
      }
    }
  },

  /**
   * Remove um evento
   * @param  {String} name Nome do evento
   */
  remove: function remove(name) {
    if (!name) {
      throw new Error('O parametro "name" é obrigatório');
    }

    delete this.list[name];
  },

  /**
   * Dispara um evento
   * @param  {String} name Nome do evento
   * @param  {Object} data Dados do evento
   */
  trigger: function trigger(name, data) {
    var postMessageObject = {
      data: data,
      from: MdHub.module.name,
      name: name,
      type: 'event',
      version: MdHub.module.version + '.' + MdHub.module.build
    };

    if (!name) {
      throw new Error('O parametro "name" é obrigatório');
    }

    // Dispara o evento para todos os iframes MdHub Client (broadcast)
    MdHub.postMessage.send(postMessageObject);

    // O evento é enviado via postMessage (pelo MdHub Server) para
    // todos os módulos. Como o MdHub Server não recebe esse postMessage
    // precisamos chamar os listeners (que o MdHub Server possa estar ouvindo)
    // do evento
    if (MdHub.mode === 'server') {
      this.call(name, data, postMessageObject);
    }
  }
};
